export default function Unauthorized() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h1>403 — Access denied</h1>
      <p>You are not authorized to view this page.</p>
    </div>
  );
}
